import { IField } from "@/api/AppApi/services/builder/interfaces/interfaces";
import { useEffect } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import FileThumbmail from "../upload-files-helpers/file-thumbmail/FileThumbmail";
import FileThumbmailSlider from "./FileThumbmailSlider";
import SvgUploadFiles from "../SvgUploadFiles";
import { TempFile, supportedFileExts } from "../upload-files-helpers/upload";
import InputErrorMsg from "../../../form-builder-helpers/InputErrorMsg";
import { getIsImage } from "../HookUploadOneFile";
import ToastForUpload from "../upload-files-helpers/ToastForUpload";
import { useUploadFiles } from "./useUploadFiles";
import { useTranslation } from "@/hooks/localization/useTranslations";
interface Props {
  field: IField;
  form: UseFormReturn<FieldValues, any>;
}
const HookUploadFiles: React.FC<Props> = ({ form, field }) => {
  const {
    filesUrls,
    setFilesUrls,
    msgErr,
    setMsgErr,
    handleUpload,
    handleRemove,
  } = useUploadFiles();
  const t = useTranslation();
  const fConfig = field.configurations;
  const initState: TempFile[] =
    field?.value && Array.isArray(field?.value)
      ? field?.value
          ?.filter((val) => typeof val === "string")
          .map((val: string, idx: number): TempFile => {
            return { id: idx, url: val, name: val, isImage: getIsImage(val) };
          })
      : [];
  useEffect(() => {
    setTimeout(() =>
      form.setValue(
        fConfig.key,
        filesUrls.filter((f) => f.url !== "").map((f) => f.url),
      ),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filesUrls]);
  useEffect(() => {
    setFilesUrls(initState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field?.value]);
  return (
    <div>
      {msgErr.length > 0 && (
        <ToastForUpload
          message={msgErr}
          show={msgErr.length > 0}
          setShow={() => setMsgErr([])}
        />
      )}
      {filesUrls?.length > 0 && (
        <FileThumbmailSlider spacing={2}>
          {filesUrls?.map((f, index) => (
            <FileThumbmail
              key={f.id}
              file={f}
              onRemoveClick={() => handleRemove(index)}
            />
          ))}
        </FileThumbmailSlider>
      )}
      <label className="upload-btn">
        <input
          type="file"
          multiple={true}
          accept={supportedFileExts.join(",")}
          {...form.register(fConfig.key, {
            onChange: (e) => handleUpload((e.target as HTMLInputElement).files),
            required:
              fConfig.is_required && !filesUrls?.[0]?.url
                ? t.this_field_is_required
                : "",
          })}
        />
        <div className=" d-flex align-items-center gap-1 justify-content-center">
          <SvgUploadFiles />
          <p style={{ maxWidth: 300 }} className="m-0 category-label-advance">
            {fConfig.placeholder}
          </p>
        </div>
      </label>
      {fConfig.hint && <div className="field-hint">{fConfig.hint}</div>}
      {form.formState.errors[fConfig.key] && (
        <InputErrorMsg
          errorMsg={form.formState.errors[fConfig.key]?.message as string}
        />
      )}
    </div>
  );
};

export default HookUploadFiles;
